import styled from 'styled-components';

export const FootNote: any = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  margin: 0 auto;
  color: #a9a9a9;
`;
